module.exports = __webpack_public_path__ + "img/wholeteam.d8e2d56e.png";